import { HttpEvent, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, EMPTY, Observable, shareReplay, switchMap, throwError } from 'rxjs';
import { AuthHttpService } from 'app/services/auth.http.service';

let refreshTokenRequest$: Observable<{ accessToken: string; refreshToken: string }> | null = null;

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const authService = inject(AuthHttpService);
  const accessToken = localStorage.getItem('accessToken');
  const invitedByUserId = localStorage.getItem('invitedByUserId');
  const utmFrom = localStorage.getItem('utmFrom');
  let headers = accessToken ? req.headers.set('Authorization', `Bearer ${accessToken}`) : req.headers;
  if (invitedByUserId) {
    headers = headers.set('x-invited-by', invitedByUserId);
  }
  if (utmFrom) {
    headers = headers.set('x-utm-from', utmFrom);
  }
  const cloneReq = req.clone({ headers });
  return next(cloneReq).pipe(
    catchError((err) => {
      const alreadyRetried = req.headers.has('X-Skip-Refresh');
      const isAuthCall = req.url.includes('web/auth');

      if (err.status === 401 && !alreadyRetried && !isAuthCall) {
        const refreshToken = localStorage.getItem('refreshToken');
        if (!refreshToken) {
          router.navigateByUrl('/login');
          return EMPTY;
        }

        if (!refreshTokenRequest$) {
          refreshTokenRequest$ = authService.refreshToken(refreshToken).pipe(shareReplay(1));
        }

        return refreshTokenRequest$.pipe(
          switchMap((response) => {
            refreshTokenRequest$ = null;
            const newAccessToken = response.accessToken;
            const newRefreshToken = response.refreshToken;

            if (!newAccessToken) {
              router.navigateByUrl('/login');
              return EMPTY;
            }

            localStorage.setItem('accessToken', newAccessToken);
            if (newRefreshToken) {
              localStorage.setItem('refreshToken', newRefreshToken);
            }

            const retryReq = req.clone({
              headers: req.headers
                .set('Authorization', `Bearer ${newAccessToken}`)
                .set('X-Skip-Refresh', '1')
            });

            return next(retryReq);
          }),
          catchError(() => {
            refreshTokenRequest$ = null;
            localStorage.removeItem('accessToken');
            localStorage.removeItem('refreshToken');
            router.navigateByUrl('/login');
            return EMPTY;
          })
        );
      }

      return throwError(() => err) as unknown as Observable<HttpEvent<any>>;
    })
  )
};
